import React, {ChangeEvent} from 'react';

interface FileSelectorProps {
    name: string;
    value: File | null;
    onChange: (file: File | null) => void;
    label?: string;
    helpText?: string;
    defaultHelpText?: string;
    required?: boolean;
    className?: string;
    disabled?: boolean;
}

const SamFileSelector: React.FC<FileSelectorProps> = ({
                                                          name,
                                                          value,
                                                          onChange,
                                                          label = 'Choose file',
                                                          helpText,
                                                          defaultHelpText = 'Upload a file',
                                                          required = false,
                                                          className = '',
                                                          disabled = false
                                                      }) => {

    const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {

        const files = e.target.files;
        onChange(files && files.length > 0 ? files[0] as File : null);
    }

    return (
        <div className={`file-upload-container ${className}`}>
            <label className="w-full flex items-center justify-center px-6 py-2 border border-slate-300 rounded-md cursor-pointer hover:bg-slate-50 bg-white">
                <span className="text-sm text-slate-600">
                  {value && value.name ? value.name : label}
                </span>
                <input
                    type="file"
                    name={name}
                    onChange={onFileChange}
                    className="hidden"
                    required={required}
                    disabled={disabled}
                />
            </label>
            <p className="mt-1 text-xs text-slate-500">
                {helpText === "" ? null : helpText || defaultHelpText}
            </p>
        </div>
    );
};

export default SamFileSelector;